import { collection, addDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

class ContactService {
  async saveContact(data) {
    try {
      const docRef = await addDoc(collection(db, 'contacts'), data);
      return { success: true, message: 'Contact saved successfully!', id: docRef.id };
    } catch (error) {
      return { success: false, message: error.message };
    }
  }
}

export default ContactService;
